var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-footer"},_vm._l((_vm.menus),function(item){return _c('div',{key:item.path,class:{
            active: item.path === _vm.$route.meta.name,
            'has-on': item.path === _vm.$route.meta.name && item.iconOn,
        },on:{"click":function($event){return _vm.handleClick(item)}}},[_c('div',{staticClass:"icon-box"},[_c('img',{attrs:{"src":item.path === _vm.$route.meta.name && item.iconOn ? item.iconOn : item.icon,"alt":""}})]),_c('span',[_vm._v(_vm._s(item.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }